import { render, staticRenderFns } from "./RespuestaSencilla.vue?vue&type=template&id=140c1413"
import script from "./RespuestaSencilla.vue?vue&type=script&lang=js"
export * from "./RespuestaSencilla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports